import { render, staticRenderFns } from "./SearchType.vue?vue&type=template&id=edb445fc&scoped=true&"
import script from "./SearchType.vue?vue&type=script&lang=ts&"
export * from "./SearchType.vue?vue&type=script&lang=ts&"
import style1 from "./SearchType.vue?vue&type=style&index=1&id=edb445fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb445fc",
  null
  
)

export default component.exports